const config = require('./config.yaml');
import {toggleInputEmptiness, checkFields} from 'component/form';
const text = require('./text.yaml')[templateVars.lang];
let shareForm = null;
import {reloadCaptcha, setValidState} from 'component/captcha';
import {enablePreloaderInItem, disabelPreloaderInItem} from 'component/preloader';
const KEY_ESCAPE = 27;

function ShareForm(formSelector) {
	const $share = $(formSelector);
	const $captcha = $share.find('.captcha');
	const $modalLayer = $share.parents('.modal-layer');
	const $shareInput = $share.find('.js-share__textinput');
	const $closeButton = $share.find('.js-share__close');
	const $submitButton = $share.find('.js-form__submit-button');
	const $shareForm = $share.find('.js-share__form');
	const $shareFields = $('.js-share__textinput');

	function closeForm() {
		$share.velocity('transition.bounceUpOut', 500, () => {
			if (config.cleanOnClose) {
				$share.find('form')[0].reset();
				$share.find('.js-share__form').parsley().reset();
				$share.find('.form__item--smart-placeholder').removeClass('is-not-empty');
			}
		});
		$modalLayer.velocity('transition.fadeOut', {delay: 100}, 500);
	}

	this.openForm = function () {
		checkFields($shareFields);

		$modalLayer.velocity('transition.fadeIn');
		$share.velocity('transition.bounceDownIn', {delay: 100}, 500);
	};

	window.Parsley
		.addValidator('captcha', {
			requirementType: 'boolean',
			validateString: function (value, requirement) {
				return requirement;
			}
		});

	function sendData() {
		setValidState($captcha, true);
		enablePreloaderInItem($submitButton);

		$shareForm.ajaxSubmit({
			type: 'POST',
			dataType: 'json',
			data: {page: templateVars.page},
			success: () => {
				disablePreloaderInItem($submitButton);
				closeForm();

				if (window.Noty) {
					window.Noty.notification(text['share-submitted-successfully']);
				}
			},
			error: (response) => {
				reloadCaptcha($captcha);
				const errorId = JSON.parse(response.responseText).errorId;
				disablePreloaderInItem($submitButton);

				if (errorId === 'WrongCaptcha') {
					setValidState($captcha, false);
					$share.find('.js-captcha__text').parsley().validate();
				} else {
					closeForm();
					if (window.Noty) {
						window.Noty.notification(text['share-sending-error'], text['share-sending-error-title']);
					}
				}
			}
		});
	}

	$submitButton.on('click', () => {
		setValidState($captcha, true);

		if ($('.js-share__form').parsley().validate()) {
			sendData();
		}
	});

	$share.find('.js-share__form').parsley({
		errorClass: 'form__label-error',
	});
	$closeButton.on('click', closeForm);
	$(document).on('keydown', (e) => {
		if (e.keyCode == KEY_ESCAPE && $modalLayer.is(':visible')) {
			closeForm();
		}
	});

	global.blurOnLeave(this);
}

$('.js-share-form-button').on('click', function (e) {
	if (!shareForm) {
		shareForm = new ShareForm('.form--share');
	}

	shareForm.openForm();
	return false;
});

module.exports = ShareForm;



// WEBPACK FOOTER //
// ./temp/components/share-to-email/index.js